import src from "IMAGE";
export default { src, width: 342, height: 88, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AEFODUJYahNaKjENQgsLDEkLCwxGDQ0OVQwMDU4MDA1PAEFODkJIVhBIFRkHJQkJCjsJCQk4CQkKOwgICTQICAgyTNkItiv6QVIAAAAASUVORK5CYII="};
